import { inject, Injectable, NgZone } from '@angular/core';
import { buffer, firstValueFrom, fromEvent, interval, merge, of, Subject, throttleTime } from 'rxjs';
import { scan } from 'rxjs/operators';
import { StateManager } from '../state-manager/state-manager.service';
import { addSeconds, isAfter } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class TimeoutService {
  private _idleSeconds: number = 0;
  private _maxIdleSeconds: number = 4 * 60;
  private _sessionBuffer: number = 90;
  stateManager = inject(StateManager);

  constructor(private zone: NgZone) {}

  init(session: any) {
    merge(
      ...['click', 'wheel', 'scroll', 'mousemove', 'touchstart', 'keydown', 'resize'].map(ev => fromEvent(document, ev))
    )
      .pipe(buffer(interval(1_000)))
      .subscribe(events => {
        if (events?.length === 0) {
          this._idleSeconds++;
        } else {
          this._idleSeconds = 0;
          // Reload session if it ends within next 90 seconds
          if (isAfter(addSeconds(new Date(), this._sessionBuffer), session.expiresAt)) {
            session.updateSession(undefined, session.userBank, false).subscribe(() => {});
          }
          if (isAfter(addSeconds(new Date(), 1), session.expiresAt) && this.stateManager.access_token) {
            this.stateManager.delete('expires_at');
            this.stateManager.delete('access_token');
            window.location.reload();
          }
        }
        if (session.isLoggedIn() && this._maxIdleSeconds === this._idleSeconds) {
          session.showInactivityCountdown();
          this._idleSeconds = 0;
        }
      });
    return firstValueFrom(of(true));
  }
}
